import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {
  Paper,
  CardContent,
  CardTitle,
  Image,
} from '@thd-olt-component-react/core-ui';
import { getVideoId } from '../../helpers/helpers';
import VideoPlayer from '../VideoPlayer/VideoPlayer.component';
import moduleStyles from './PromotionalNavigation2AcrossMobile.scss';

const ActionIcon = (
  <Image src="https://assets.thdstatic.com/images/v1/caret-orange.svg" alt="" />
);

const styles = classNames.bind(moduleStyles);

function hasRequiredImageData({image}) {
  const type = typeof image;

  if (type !== 'object') {
    return null;
  }

  if (
    (image === null || Array.isArray(image) || Object.keys(image).length === 0)
  ) {
    return null;
  }

  /**
   * I've often seen etch responses contain a string
   * with a single space in it instead of the empty string
   * or `null`.
   *
   * We don't want to render a card without an image URL.
   */
  if (!image.src || image.src === ' ') {
    return null;
  }

  return image;
}

function hasRequiredText({ heading }) {
  /**
   * Again, here we are handling the strange edge case where
   * we're often getting strings with a single space in them
   * in the response from Etch / the content query.
   */
  return typeof heading === 'string' && heading.length && heading !== ' ';
}

const PromotionalNavigation2AcrossMobile = (props) => {
  const { opts, channel } = props;
  const { cards } = opts;

  if (!cards.length) return null;

  return (
    <div className={styles('promotional-navigation')}>
      {cards.map((card) => {
        if (!hasRequiredImageData(card) || !hasRequiredText(card)) return null;

        const { id, link, heading, subheading, image = {} } = card;
        const videoId = getVideoId(link);

        /**
         * I've often seen etch responses contain a string
         * with a single space in it instead of the empty string
         * or `null`.
         *
         * We don't want to include an alt text string that contains
         * a space in it. If there's no alt text provided, which
         * this space seems to indicate, we should just make it
         * the empty string.
         */
        let imageAlt = image.alt !== ' ' ? image.alt : '';

        const CardContentWrapper =
          typeof link === 'string' && link.length && !videoId ? 'a' : 'div';

        const isArrowRendered = !videoId ? {content: ActionIcon} : null;

        return (
          <Paper key={id} className={styles("card")}>
            <CardContentWrapper style={{ display: "contents" }} href={link}>
              <CardContent
                noPadding
              >
                {videoId ? (
                  <VideoPlayer
                    channel={channel}
                    videoId={videoId}
                    videoStill={image.src}
                    withOverlay
                  />
                ) : (
                  <Image alt={imageAlt} src={image.src} />
                )}
              </CardContent>
              <div className={styles("centered-card-title")}>
                <CardTitle
                  title={heading}
                  action={isArrowRendered}
                  subtext={{ text: subheading }}
                />
              </div>
            </CardContentWrapper>
          </Paper>
        );
      })}
    </div>
  );
};

PromotionalNavigation2AcrossMobile.displayName =
  'PromotionalNavigation2AcrossMobile';

PromotionalNavigation2AcrossMobile.propTypes = {
  opts: PropTypes.shape({
    cards: PropTypes.arrayOf(
      PropTypes.shape({
        link: PropTypes.string,
        id: PropTypes.string,
        heading: PropTypes.string,
        subheading: PropTypes.string,
        image: PropTypes.shape({
          src: PropTypes.string,
          alt: PropTypes.string,
        }),
      })
    ),
  }),
};

PromotionalNavigation2AcrossMobile.defaultProps = {
  opts: {},
};

export default PromotionalNavigation2AcrossMobile;
